import { render } from "./Skills.vue?vue&type=template&id=b893d6de&scoped=true&ts=true"
import script from "./Skills.vue?vue&type=script&lang=ts"
export * from "./Skills.vue?vue&type=script&lang=ts"

import "./Skills.vue?vue&type=style&index=0&id=b893d6de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b893d6de"]])

export default __exports__